import React from 'react'
import './Home.css'

import HeroSection from './sections/HeroSection'
import Trends from './sections/Trends'
import ActivityMapSection from './sections/ActivityMapSection'
import CallToActionBand from './sections/CallToActionBand'
import Footer from '../../components/Footer'
import { SpecializedServicesSection } from './sections/SpecializedServices'

export default function Home() {
  return (
    <div className="home">
      <HeroSection />
      <Trends />
      <SpecializedServicesSection />
      <ActivityMapSection />
      <CallToActionBand />
      <Footer />
    </div>
  )
}
